import Script from 'next/script'
import { useMemo } from 'react'

const thirdPartyScripts = [
  {
    id: 'google-analytics',
    Component: ({ id, nonce, params }) => (
      <Script
        id={id}
        key={id}
        src={`https://www.googletagmanager.com/gtag/js?id=${params.googleAnalyticsId}`}
        strategy="afterInteractive"
        nonce={nonce}
      />
    ),
    condition: params => !!params.googleAnalyticsId
  },
  {
    id: 'gtag-init',
    Component: ({ id, nonce, params }) => (
      <Script id={id} strategy="afterInteractive" nonce={nonce}>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${params.googleAnalyticsId}', {
            page_path: window.location.pathname,
          });
        `}
      </Script>
    ),
    condition: params => !!params.googleAnalyticsId
  }
]

export default function ThirdPartyScripts({ nonce, googleAnalyticsId }) {
  const filteredScripts = useMemo(
    () =>
      thirdPartyScripts.filter(script =>
        typeof script.condition === 'function' ? script.condition({ googleAnalyticsId }) : script.condition
      ),
    [googleAnalyticsId]
  )

  if (!filteredScripts.length) return null

  return (
    <>
      {filteredScripts.map(script => (
        <script.Component key={script.id} id={script.id} nonce={nonce} params={{ googleAnalyticsId }} />
      ))}
    </>
  )
}
